export const SupportPremiumLevelId = {
  free: 0,
  included: 1,
  plus: 2,
  pro: 3,
  business: 4,
} as const;

export const SectionName = {
  contact_mail: 'contact_mail',
  contact_phone: 'contact_phone',
  contact_callmeback: 'contact_callmeback',
  contact_chat: 'contact_chat',
  contact_mail_jelastic: 'contact_mail_jelastic',
  technical_emergency: 'technical_emergency',
} as const;

export const SwissBackupStorage = {
  acronis: 'Acronis',
  cloud: 'Cloud (FTP/Swift/S3)',
} as const;
